<template>
    <div style="overflow: auto;position:relative;">
        <!--内容区-->
<!--        <input type="file" class="file" value="../../../../assets/还算计视觉.ipynb">-->
<!--        <Button @click="jsReadFiles">Click</Button>-->
        <div id='doc' style="height:1000px;overflow: auto;"></div>
        <Loading :spinShow="show"></Loading>
        <!--END-->
    </div>
</template>
<script>
    import {mapActions,mapState} from 'vuex'
    import marked from 'marked';
    import katex from 'katex';
    import prismjs from 'prismjs';
    import 'prismjs/components/prism-python'
    import 'prismjs/components/prism-r.min'
    import {nbNotebook} from "../../../../assets/js/nbv"
    import Loading from "@/components/common_components/loading/loading_view";
    export default {
        name:"notebook",
        props:{
            template:String
        },
        components:{
            Loading
        },
        data(){
            return {
                show:true,
                ipynb: ''
            }
        },
        methods:{
            ...mapActions({
                getContestCode:'contest/getContestCode'
            })
        },
        computed:{
            ...mapState({
                contestInfo:state=>state.contest.contest_info
            })
        },
        created(){
            window.marked = marked;
            window.katex = katex
            // window.prism = prismjs
        },
        mounted() {
            let _this = this;
            let id = this.$route.params.id;
            if(id > 0 ){
                // 获取当前竞赛代码
                this.getContestCode({
                    id:id,
                    callback:res=>{
                        _this.ipynb = JSON.parse(res.content);
                        let doc = document.getElementById("doc");
                        nbNotebook.render(_this.ipynb,doc);
                        this.show = false;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    @import "~prismjs/themes/prism.css";
    @import "~katex/dist/katex.css";
    .nb-iframe-resize{
        /* min-height: 30vh; */
        display: block;
        /* margin: auto; */
        width: 100%;
        height: 5000px;
        border: none;
        margin: 0;
    }

    div#instructions {
        max-width: 960px;
        font-size: 2em;
        color: rgb(108, 108, 108);
        text-align: center;
        padding-top: 10%;
        margin: 0 auto;
    }
    div#instructions small {
        font-size: .7em;
    }
    div#dropzone {
        position: fixed;
        top: 0; left: 0;
        width: 100%; height: 100%;
        z-index: 1000;
        background-color: #7d7;
        opacity: 0;
        transition: visibility 500ms, opacity 500ms;
    }
    select#file-selector {
        display: none;
        /*display: block;*/
        font-size: 2em;
        margin: 0 auto;
    }
    button#download-notebook {
        display: none;
        margin: 1em auto 0 auto;
    }
    input#github-link {
        font-size: 1em;
        text-align: center;
        width: 60%;
        margin: .3em auto;
    }
    input#github-link::placeholder {
        color: #ccc;
    }
    div#serving-info {
        font-size: 1.2em;
        font-style: italic;
        margin-top: 1em;
        text-align: center;
    }
    div#contact {
        width: 42em;
        margin: 5em auto 0 auto;
        font-style: italic;
    }
</style>
